import React, { Component, PropTypes } from 'react'
import acc from 'accounting'

class ListData extends Component {
  render() {
    const { data, total } = this.props

    return (
      <table className="table table-bordered table-condensed">
        <thead>
          <tr>
            <th width="5%">#</th>
            <th width="15%">Fee Code</th>
            <th>Fee Description</th>
            <th width="15%">Account Code</th>
            <th width="10%">UACS</th>
            <th width="15%" className="text-right">Amount (Php)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d, k) => {
            return (
              <tr key={k}>
                <td>{k+1}</td>
                <td>{d.get('fee_code')}</td>
                <td>{d.get('fee_name')}</td>
                <td>{d.get('acct_code')}</td>
                <td>{d.get('uacs')}</td>
                <td className="text-right">{acc.formatNumber(d.get('amount'), 2)}</td>
              </tr>
            )
          })}
          <tr>
            <td colSpan="5" className="text-right"><strong>TOTAL:</strong></td>
            <td className="text-right"><strong>{acc.formatNumber(total, 2)}</strong></td>
          </tr>
        </tbody>
      </table>
    )
  }
}

ListData.propTypes = {
  data: PropTypes.object,
  total: PropTypes.number,
}

export default ListData



// WEBPACK FOOTER //
// ./src/containers/Print/Reports/Collections/list-data.js